// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1yOxK","signatureButtonsRight":"ModalSign_signatureButtonsRight__1HY-e"};